/**
 * Trailing-edge debounce. `TArgs` is inferred from `func`, so the returned wrapper takes the same
 * arguments; `this` stays generic because the wrapper forwards its receiver through `apply`.
 */
function debounce<TArgs extends unknown[]>(func: (...args: TArgs) => unknown, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | null;
  return function (this: unknown, ...args: TArgs) {
    const context = this;
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      timeout = null;
      if (typeof func === "function") func.apply(context, args);
    }, wait);
  };
}

export default debounce;
